/**
 * Created by gbray on 03/05/2017.
 */
export class TableActionButtons {

  public displayDeleteButton;
  public displayDuplicateButton;
  public displayAddButton;
  public displaySearchButton;
  public displayCalculateButton;
  public displayImportButton = false;
  public displayEditButton = false;
  public displayProtectButton = false;
  public displaySlideToggle = false;

  constructor(displayDeleteButton: boolean, displayDuplicateButton: boolean, displayAddButton: boolean, displaySearchButton: boolean, displayCalculateButton: boolean) {
    this.displayDeleteButton = displayDeleteButton;
    this.displayDuplicateButton = displayDuplicateButton;
    this.displayAddButton = displayAddButton;
    this.displaySearchButton = displaySearchButton;
    this.displayCalculateButton = displayCalculateButton;
  }
}
